const IPV4_OCTET = '(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])'
const IPV4_PATTERN = new RegExp(`^${IPV4_OCTET}(?:\\.${IPV4_OCTET}){3}$`)
const CIDR_PATTERN = new RegExp(`^${IPV4_OCTET}(?:\\.${IPV4_OCTET}){3}/(?:[0-9]|[12][0-9]|3[0-2])$`)
const HOSTNAME_LABEL_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i

const isHostname = (value: string): boolean => {
  if (value.length < 1 || value.length > 253 || !/[a-z]/i.test(value)) {
    return false
  }

  return value.split('.').every((label) => HOSTNAME_LABEL_PATTERN.test(label))
}

export const normalizeAnalyticsSuppressionRule = (value: string): string => {
  const normalized = value.trim()

  if (/[a-z]/i.test(normalized) && normalized.endsWith('.')) {
    return normalized.slice(0, -1).toLowerCase()
  }

  return isHostname(normalized) ? normalized.toLowerCase() : normalized
}

export const validateAnalyticsSuppressionRule = (value: string): string | null => {
  const normalized = normalizeAnalyticsSuppressionRule(value)

  if (!normalized) {
    return 'Enter a hostname, IPv4 address, or IPv4 CIDR.'
  }

  return IPV4_PATTERN.test(normalized) || CIDR_PATTERN.test(normalized) || isHostname(normalized)
    ? null
    : 'Use a hostname, IPv4 address, or IPv4 CIDR. IPv6 is not supported yet.'
}
